import {RouteLocation} from "vue-router";
import SecurityUtils from "@/utils/login/SecurityUtils.ts";
import LoginUtils from "@/utils/login/LoginUtils.ts";
import Translator from "@/utils/common/Translator.ts";

export interface SecuredRoute {
  entity: string;
  capabilities: string[];
}

declare module 'vue-router' {
  interface RouteMeta {
    secured?: SecuredRoute;
  }
}

type RouteWithMeta = Pick<RouteLocation, "meta">;

export default class RouteSecurity {
  private static readonly MISSING_CAPABILITY_MESSAGE = "The user {0} does not have the capability {1} on the type {2}";

  static canEnter(route: RouteWithMeta): boolean {
    return !this.findMissingCapability(route);
  }

  static missingCapabilityMessage(route: RouteWithMeta): string {
    const secured = route.meta.secured;
    const missingCapability = this.findMissingCapability(route);
    if (!secured || !missingCapability)
      return "";
    return this.missingCapabilityMessageFor(secured.entity, missingCapability);
  }

  static missingCapabilityMessageFor(entity: string, capability: string): string {
    const user = LoginUtils.loginInfo?.userInfo;
    return Translator.translate(this.MISSING_CAPABILITY_MESSAGE)
      .replace("{0}", Translator.getName(user?.name1, user?.name2) || user?.code || "")
      .replace("{1}", Translator.translateId(capability))
      .replace("{2}", Translator.translateId(entity));
  }

  private static findMissingCapability(route: RouteWithMeta): string | undefined {
    const secured = route.meta.secured;
    if (!secured)
      return undefined;
    return secured.capabilities.find(capability => !SecurityUtils.userCan(secured.entity, capability));
  }
}
